import TransformIcon from '@material-ui/core/SvgIcon/SvgIcon';
import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '../Common/Grid';

import Icon from '../Common/Icon';
import getNoDataCellComponent from '../Common/NoDataCellComponent';

import styles from './styles';

const COLUMNS = [
  { name: 'icon', title: ' ' },
  { name: 'name', title: 'Name' },
  { name: 'relativeTo', title: 'Relative To' },
  { name: 'qa', title: 'Quality Assurance' },
  // { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'icon', width: 70 },
  // { columnName: '', width: 0 },
  // { columnName: '', width: 0 },
  // { columnName: '', width: 0 },
];

const getCellComponent = ({ row, column, value }) => {
  switch (column.name) {
    case 'icon':
      return (<Icon name={value || 'barcode'} style={styles.icon}/>);
    case 'relativeTo':
      return toWords(value);
    case 'qa':
      return value ? 'Yes': 'No';
    default:
      return value;
  }
}

const toWords = (relativeTo) => {
  switch (relativeTo) {
    case 'origin':
      return 'Origin';
    case 'destination':
      return 'Destination';
    default:
      return 'Custom';
  }
};

class StagesGrid extends Component {
  static propTypes = {
    stages: PropTypes.array.isRequired,
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
  };

  state = {};

  render() {
    const { stages } = this.props;
    if (!stages) {
      return null;
    }

    return (<Grid
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      data={{ data: stages }}
      fetch={_.noop}
      cellComponent={getCellComponent}
      noDataCellComponent={getNoDataCellComponent(<TransformIcon style={styles.noData}/>, 'stages')}
    />)
  }
}

export default StagesGrid;



// WEBPACK FOOTER //
// ./src/components/StagesGrid/index.js